import { TFontVariant, TTheme } from '@/core/theme'
import { styled } from '@mui/material'

export const TextButtonContainer = styled('button')<{
    theme?: TTheme
    fontSizeVariant?: TFontVariant
    padding?: string
}>`
    background: none;
    border: none;
    cursor: pointer;
    color: ${({ theme }) => theme?.colors?.greys?.[500]};
    font-size: ${({ theme, fontSizeVariant }) =>
        theme?.fonts?.[fontSizeVariant || 's-regular']?.fontSize};
    font-weight: ${({ theme, fontSizeVariant }) =>
        theme?.fonts?.[fontSizeVariant || 's-regular']?.fontWeight};
    transition: color 0.2s;
    padding: ${({ padding }) => padding || '0 32px'};
    &:hover {
        color: ${({ theme }) => theme?.colors?.greys?.[700]};
    }
`
